var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24-.003H0v15.998h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M14.925 8A3.375 3.375 0 0112 10.557 3.375 3.375 0 019.075 8a2.925 2.925 0 115.85 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M14.925 8a2.925 2.925 0 01-5.85 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M15.868 9.808l-.774.774.514.515.775-.774-.515-.515zm-1.284 1.297l-.774.775.513.514.775-.774-.514-.514v-.001zm2.842.248l-.774.774.515.515.774-.774-.515-.515zm-1.297 1.293l-.774.773.514.515.774-.774-.514-.514zm.52-2.065l-.775.774.515.514.774-.774-.514-.514zm-1.295 1.296l-.775.775.515.515.774-.774-.514-.515zm-.253-9.04l-.514.515 2.068 2.069.515-.515L15.1 2.838zm-.78.779l-.514.514.774.774.514-.514-.774-.774zM15.618 4.9l-.515.514.774.775.515-.515-.774-.774zm.255-2.835l-.515.514.775.775.515-.515-.775-.774zm1.285 1.29l-.515.514.774.775.515-.515-.774-.774zm-10.577 8l-.514.514 2.068 2.068.515-.514-2.069-2.068zm2.057.516l-.515.515.774.774.515-.514-.774-.775zm-1.293-1.29l-.513.515.774.774.514-.514-.775-.774zm.776-.772l-.515.514 2.069 2.069.514-.514-2.068-2.069zm.003-7.753L6.055 4.124l.515.515L8.638 2.57l-.514-.515zm.78.773L6.837 4.897l.515.514 2.067-2.068-.513-.514zm.77.78L7.607 5.677l.514.514 2.069-2.068-.515-.514z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKr);
export default __webpack_public_path__ + "static/media/kr.1545e6a1d8dc3ce6a65f3c2351233dcd.svg";
export { ForwardRef as ReactComponent };